import Vue from 'vue'

const recommendationModule = {
  namespaced: true,
  state: {
    recommendationWidgets: {},
    periods: {
      first: {
        start: null,
        end: null
      },
      second: {
        start: null,
        end: null
      }
    },
    reportsWidgets: {
      first: {
        widgets: {}
      },
      second: {
        widgets: {}
      }
    },
    selectedWidgets: [],
    loadingWidgets: false,
    loadingReportsFirst: false,
    loadingReportsSecond: false
  },

  mutations: {
    setFirstPeriod: (state, period) => (state.periods.first = period),
    setSecondPeriod: (state, period) => (state.periods.second = period),
    setRecommendationWidgets: (state, widgets) => (state.recommendationWidgets = widgets),
    setReportsWidgetsFirst: (state, reports) => (state.reportsWidgets.first = reports),
    setReportsWidgetsSecond: (state, reports) => (state.reportsWidgets.second = reports),
    setLoadingWidgets: (state, loading) => (state.loadingWidgets = loading),
    setLoadingReportsFirst: (state, loading) => (state.loadingReportsFirst = loading),
    setLoadingReportsSecond: (state, loading) => (state.loadingReportsSecond = loading),
    setSelectedWidgets: (state, widgets) => (state.selectedWidgets = widgets)
  },

  actions: {
    GET_RECOMMENDATION_REPORTS: ({ state, dispatch, commit, rootGetters }, data) => {
      const promise1 = new Promise(async () => {
        if (
          state.periods.first.start !== data.firstPeriod.start ||
          state.periods.first.end !== data.firstPeriod.end ||
          state.selectedWidgets.length !== data.widgets.length
        ) {
          commit('setLoadingReportsFirst', true)
          commit('setFirstPeriod', data.firstPeriod)

          const body = {
            widgets: data.widgets,
            start: data.firstPeriod.start,
            end: data.firstPeriod.end,
            exclude_invalid_data: false
          }

          try {
            const response = await Vue.http.post(
              `${rootGetters.getBackendUrl}/reports/recommendations`,
              body,
              {
                headers: rootGetters.getAllResponseHeaders
              }
            )

            if (response.ok && response.statusText === 'OK') {
              commit('setReportsWidgetsFirst', response.body)
            }

            commit('setLoadingReportsFirst', false)
          } catch (e) {
            commit('setLoadingReportsFirst', false)
            console.error(e)
            throw new Error(e.statusText)
          }
        }
      })

      const promise2 = new Promise(async () => {
        if (data.secondPeriod.start === null || data.secondPeriod.end === null) return

        if (
          state.periods.second.start !== data.secondPeriod.start ||
          state.periods.second.end !== data.secondPeriod.end ||
          state.selectedWidgets.length !== data.widgets.length
        ) {
          commit('setLoadingReportsSecond', true)
          commit('setSecondPeriod', data.secondPeriod)

          const body = {
            widgets: data.widgets,
            start: data.secondPeriod.start,
            end: data.secondPeriod.end,
            exclude_invalid_data: false
          }

          try {
            const response = await Vue.http.post(
              `${rootGetters.getBackendUrl}/reports/recommendations`,
              body,
              {
                headers: rootGetters.getAllResponseHeaders
              }
            )

            if (response.ok && response.statusText === 'OK') {
              commit('setReportsWidgetsSecond', response.body)
            }

            commit('setLoadingReportsSecond', false)
          } catch (e) {
            commit('setLoadingReportsSecond', false)
            console.error(e)
            throw new Error(e.statusText)
          }
        }
      })

      commit('setSelectedWidgets', data.widgets)

      return Promise.all([promise1, promise2])
    },

    GET_RECOMMENDATION_WIDGETS: async ({ dispatch, commit, rootGetters }) => {
      commit('setLoadingWidgets', true)

      try {
        const response = await Vue.http.get(
          `${rootGetters.getBackendUrl}/analytics/get_recommendation_widgets`,
          {
            headers: rootGetters.getAllResponseHeaders
          }
        )

        if (response.ok && response.statusText === 'OK') {
          commit('setRecommendationWidgets', response.body)
        }

        commit('setLoadingWidgets', false)
      } catch (e) {
        commit('setLoadingWidgets', false)
        console.error(e)
        throw new Error(e.statusText)
      }
    }
  }
}

export default recommendationModule



// WEBPACK FOOTER //
// ./src/store/modules/reports/modules/recommendation.js